export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES';
export const UPDATE_USER_PREFERENCES_SUCCESS = 'UPDATE_USER_PREFERENCES_SUCCESS';
export const UPDATE_USER_PREFERENCES_FAILURE = 'UPDATE_USER_PREFERENCES_FAILURE';

export const SWITCH_CLIENT = 'SWITCH_CLIENT';
export const UPDATE_USER_LAST_CLIENT = 'UPDATE_USER_LAST_CLIENT';
export const UPDATE_USER_LAST_CLIENT_SUCCESS = 'UPDATE_USER_LAST_CLIENT_SUCCESS';
export const UPDATE_USER_LAST_CLIENT_FAILURE = 'UPDATE_USER_LAST_CLIENT_FAILURE';
